import {RoomImage, RoomMetadata, RoomOccupancy} from '../../room/model';
import {Price, Tax} from '../../../core/money';

export enum RateDepositType {
  PercentageWithoutExtras = 'PercentageWithoutExtras',
  FirstNightWithoutExtras = 'FirstNightWithoutExtras',
}

export enum RateQualifierType {
  RoomOnly = 'RoomOnly',
  BreakfastIncluded = 'BreakfastIncluded',
  HalfBoard = 'HalfBoard',
  FullBoard = 'FullBoard',
  AllInclusive = 'AllInclusive',
  SelfCatering = 'SelfCatering',
  Package = 'Package',
  BreakfastIncludedPackage = 'BreakfastIncludedPackage',
  HalfBoardPackage = 'HalfBoardPackage',
  FullBoardPackage = 'FullBoardPackage',
  AllInclusivePackage = 'FullBoardPackage',
  SelfCateringPackage = 'SelfCateringPackage',
}

export enum CancelConditionType {
  Short = 'Short',
  Default = 'Default',
}

export interface CancelCondition {
  name: Array<RoomMetadata<CancelConditionType>>;
  summary: Array<RoomMetadata<CancelConditionType>>;
}

export interface Rate {
  rateId: string;
  offerId: string;
  price: Price;
  availableQuantity: number;
  taxes: Tax;
  occupancy: RoomOccupancy;
  internetIncluded?: string;
  breakfastIncluded?: string;
  selectedQuantity?: number;
  description: RateInformation; //TODO Always present from jj experience
}

export interface RateInformation {
  bookingFees: {percent: number, nominal: number};
  cancelConditions: CancelCondition;
  code: string;
  deposit: { depositType: RateDepositType, percent: number};
  name: string;
  pictures: RoomImage[];
  qualifier: RoomMetadata<RateQualifierType>;
  sortOrder: number;
  summary: Array<RoomMetadata<string>>;
}

export interface RateModel {
  rateId: number;
  hotelId: number;
  code: string;
  name: string;
  currencyCode: string;
  information: {
    type: RoomMetadata<string>,
    qualifier: RoomMetadata<RateQualifierType>,
    currency: string;
    summary: Array<RoomMetadata<string>>,
    pictures: RoomImage[],
    isPrivate: boolean,
    sortOrder: number,
  };
  gratuitounessPeriods: any;
  salePeriods: any;
  sellingConditions: {
    deposit: { depositType: RateDepositType; percent: number };
    useOnlinePayment: boolean;
    bookingFees: { percent: number; nominal: number },
    allowFullOnlinePayment: boolean;
    allowCallOption: boolean;
    paymentBalance: any;
  };
  cancelConditions: {
    cancelConditions: any;
    description: any;
    usePlanningConditions: boolean;
    isGuestModificationEnabled: boolean;
    isModificationEnabled: boolean;
  };
  roomIds: number[];
  occupancyIds: number[];
  extraIds: number[];
}
